import request from '@/router/axios';

const add = params => request({
  url: '/api/mcc-worker/project/save',
  method: 'post',
  data: {
    ...params,
  },
})

const getList = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/project/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

const update = params => request({
  url: '/api/mcc-worker/project/update',
  method: 'post',
  data: params,
})

const remove = ids => request({
  url: '/api/mcc-worker/project/remove',
  method: 'post',
  params: {
    ids,
  },
})

export default {
  getList,
  update,
  add,
  remove,
}
